<template>
    <BDropdownItem
        href="#"
        v-on:click.prevent="process"
        :disabled="isProcessing"
    >
        <i class="fad fa-calendar mr-3"/>Přegenerovat událost v kalendáři
    </BDropdownItem>
</template>

<script>
import {mapGetters} from "vuex"

export default {

    computed: {
        ...mapGetters({
            order: 'order/getOrder',
            isProcessing: 'order/isProcessing',
        }),
    },

    methods: {
        process() {
            this.$bvModal.msgBoxConfirm('Opravdu chcete přegenerovat událost v kalendáři?', {
                title: 'Potvrzení',
                okVariant: 'primary',
                cancelVariant: 'default',
                centered: true,
                okTitle: "Ano, přegenerovat.",
                cancelTitle: "Ne"
            })
                .then(value => {
                    if (value === true) {
                        this.$store.dispatch("order/refreshCalendarEvent", this.order.id)
                            .then((result) => {
                                if (result) {
                                    this.successMessage('Žádost o přegenerování události v kalendáři byla úspěšně vytvořena.')
                                } else {
                                    this.warningMessage('Žádost o přegenerování události v kalendáři nebyla zpracována.')
                                }
                            })
                            .catch((error) => {
                                this.errorMessage(error.response.data.message)
                            })
                    }
                })
        },

    },

}
</script>
